<template>
  <v-app-bar app color="white">
    
    <v-img :src="getMallLogoPath(user.mall.logo)" max-width="50px" max-height="50px" class="mr-3"></v-img>
    <v-toolbar-title>
      
      <span data-test="title-text" class="title">
        {{user.mall.name}}
      </span>
      | Portail du centre
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <v-img :src="picturePath || $store.state.defaultPicture" max-width="150px" contain max-height="50px" position="right"></v-img>
  
    <template v-slot:extension>
      <v-tabs align-with-title>
        <v-tab v-for="(tab, index) in tabs" :to="tab.to" :key="'tab' + index" exact>{{tab.label}}</v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon large class="mr-3" @click="$store.commit('contact/showModal')" v-bind="attrs" v-on="on">
            <v-icon>mail</v-icon>
          </v-btn>
        </template>
        Message
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="disconnectUser" v-bind="attrs" v-on="on">
            <v-icon>logout</v-icon>
          </v-btn>
        </template>
        Se déconnecter
      </v-tooltip>
      
    </template>
  </v-app-bar>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FilesPathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
import routeNames from '@/router/routeNames'
export default {
  name: 'TheTopBar',
  mixins: [FilesPathHelpersMixin],
  computed: {
    ...mapState('auth', [
      'user',
    ]),
    ...mapGetters('auth', [
      'picturePath',
    ]),
    tabs () {
      return [
        { label: 'Accueil', to: {name: routeNames.user.myHome}},
        { label: 'Saisie de données', to: {name: routeNames.user.myEntries}},
        { label: 'Mes documents', to: {name: routeNames.user.myDocuments}},
        { label: 'Mon compte', to: {name: routeNames.user.myProfile}}
      ]
    },
  },
  methods: {
    ...mapActions('auth', [
      'disconnectUser',
    ]),
  }
}
</script>
